import { render } from "./UserProfileDropdown.vue?vue&type=template&id=2a363095&scoped=true&ts=true"
import script from "./UserProfileDropdown.vue?vue&type=script&lang=ts"
export * from "./UserProfileDropdown.vue?vue&type=script&lang=ts"

import "./UserProfileDropdown.vue?vue&type=style&index=0&id=2a363095&lang=scss&scoped=true"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a363095"]])

export default __exports__